(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  class SubscribePopup extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.triggerId = this.dataset.triggerId;
      this.storageKey = 'subscribe-popup-seen:' + this.id;
      this.reopenAfterDays = parseInt(this.dataset.reopenAfterDays, 10) || 0;
    }

    connectedCallback() {
      this.querySelectorAll('[data-popup-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      // Clicking the backdrop area (outside the box) closes the popup.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('subscribe-popup-open');
      });

      // Manual trigger: any link/element referencing this popup's trigger id
      // anywhere in the theme opens it, e.g. <a href="#open-subscribe-popup">.
      if (this.triggerId) {
        const selector =
          'a[href="#' + this.triggerId + '"], [data-popup-trigger="' + this.triggerId + '"]';
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest(selector);
          if (!trigger) return;
          event.preventDefault();
          this.open();
        });
      }

      // The page reloads after a successful newsletter signup, and the
      // submitted block re-renders its success state inline. Reopen the
      // popup immediately in that case so the visitor sees it, regardless
      // of the auto-open/delay/reopen settings below.
      if (this.querySelector('.email-signup__success')) {
        this.open();
        return;
      }

      if (this.dataset.autoOpen === 'true' && this.shouldAutoOpen()) {
        const delay = (parseInt(this.dataset.autoOpenDelay, 10) || 0) * 1000;
        setTimeout(() => this.open(), delay);
      }
    }

    shouldAutoOpen() {
      const seenAt = localStorage.getItem(this.storageKey);
      if (!seenAt) return true;
      if (this.reopenAfterDays <= 0) return false;
      const daysElapsed = (Date.now() - parseInt(seenAt, 10)) / 86400000;
      return daysElapsed >= this.reopenAfterDays;
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add('subscribe-popup-open');
      localStorage.setItem(this.storageKey, Date.now().toString());
    }

    close() {
      this.dialog.close();
    }
  }

  customElements.define('subscribe-popup', SubscribePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
